<div class="cookie-dialog">
  <h2>{{ "cookie.header" | translate }} 🍪</h2>
  <p>
    {{ "cookie.message" | translate }}
  </p>

  <div class="actions">
    <button (click)="accept()" class="btn-offers" style="width: auto">
      {{ "cookie.allow" | translate }}
    </button>
    <!-- <button
      (click)="decline()"
      class="btn-offers"
      style="width: auto; height: auto"
    >
      {{ "cookie.deny" | translate }}
    </button> -->
    <!-- <button
        (click)="lang1 = 'en'"
        [ngClass]="lang1 === 'en' ? 'lang active' : 'lang'"
        (click)="setLang('en')"
      >
        EN
      </button>
      <button
        (click)="lang1 = 'pl'"
        [ngClass]="lang1 === 'pl' ? 'lang active' : 'lang'"
        (click)="setLang('pl')"
      >
        PL
      </button> -->
  </div>
</div>
